import axios from '@/utils/http';

export default (
  page = 1,
  per_page = 20,
  type = '',
  startTime,
  endTime,
  keywords,
) => {
  let url = `/multisig_orders?page=${page}&per_page=${per_page}&start_time=${startTime}&end_time=${endTime}`;
  if (type) {
    url += `&type=${type}`;
  }
  if (keywords) {
    url += `&keywords=${encodeURIComponent(keywords)}`;
  }
  return axios
    .get(url)
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};
